var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { IconButton } from "@irati/ui/src/Button";
import ImageEditor from "@irati/ui/src/ImageEditor";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import { H1, Body } from "@irati/ui/src/Typography";
var IMAGE_EDITOR_VERTICAL_PADDING = 20;
var ScaleLogoStep = /** @class */ (function (_super) {
    __extends(ScaleLogoStep, _super);
    function ScaleLogoStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            imageScale: 1
        };
        _this.onUpdate = function (imageScale) {
            _this.setState({ imageScale: imageScale });
        };
        return _this;
    }
    ScaleLogoStep.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        return (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: this.props.backToUploadLogo, icon: "backArrow" }),
            React.createElement(React.Fragment, null,
                React.createElement(H1, { marginBottom: 4 },
                    React.createElement(FormattedMessage, { id: "admin.components.scaleLogoStep.title" })),
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "admin.components.scaleLogoStep.subTitle", values: { br: React.createElement("br", null) } })),
                React.createElement(ImageEditor, { image: this.props.imageSource, width: BRAND_LOGO_DIMENSIONS.width * 2, height: BRAND_LOGO_DIMENSIONS.height * 2, border: [0, IMAGE_EDITOR_VERTICAL_PADDING], color: [0, 0, 0, 0.1], scale: this.state.imageScale, onUpdate: this.onUpdate, buttonText: formatMessage({ id: "admin.components.scaleLogoStep.imageEditor.buttonText" }), onComplete: this.props.onComplete, largeBtn: false, centerSlider: false, style: {
                        width: BRAND_LOGO_DIMENSIONS.width,
                        height: BRAND_LOGO_DIMENSIONS.height + IMAGE_EDITOR_VERTICAL_PADDING,
                        marginTop: 24
                    } }))));
    };
    return ScaleLogoStep;
}(Component));
export default injectIntl(ScaleLogoStep);
